<ion-grid fixed>
  <ion-row align-items-stretch>
    <ion-col
      class="product-item ion-no-padding"
      size="6"
      size-sm="6"
      size-lg="6"
      *ngFor="let item of productsList"
    >
      <ion-card>
        <ion-chip
          class="ion-no-padding ion-no-margin fs-1 font500 ion-text-center tertiary-chip"
          *ngIf="item?.offerTag"
        >
          {{ item?.offerTag }}</ion-chip
        >
        <ion-img
          [src]="item.img || imagePlaceholder"
          (ionError)="item.img = imagePlaceholder"
          (click)="navigateToNextPage(item)"
          style="cursor: pointer"
        >
        </ion-img>
        <ion-card-header class="ion-padding-horizontal ion-no-padding">
          <ion-card-title text-wrap class="fs-2 font500">
            <div class="line-clamp-2 card-primary-text-color">{{ item.title }}</div>
          </ion-card-title>
          <div class="card-content">
            <ion-text>
              <h5
                class="orig-price mart5 marr10 strike-price-color ion-no-margin fs-2 font600" 
                *ngIf="item.finalPrice < item.origPrice"
              >
                {{ item.origPrice | currency : currencyCode }}
              </h5>
              <h5 class="final-price mart5 primary-price-color ion-no-margin fs-3 font600">
                {{ item.finalPrice | currency : currencyCode }}
              </h5>
              <h5 class="red-text-color ion-no-margin fs-1 font500" *ngIf="item.discount > 0">
                {{ item.discount }}% {{"shared.product_card_list.off" | translate}}
              </h5>
            </ion-text>
          </div>
        </ion-card-header>
      </ion-card>
    </ion-col>
  </ion-row>
  <ng-template [ngIf]="!noPaging">
    <ion-infinite-scroll (ionInfinite)="getNextPageFromParent($event)">
      <ion-infinite-scroll-content loadingSpinner="crescent">
      </ion-infinite-scroll-content>
    </ion-infinite-scroll>
  </ng-template>
</ion-grid>
